export const DEFAULT_NOTIFICATION_TEMPLATES = [
  {
    key: "NEW_BOOKING",
    name: "New Booking",
    category: "Bookings",
    description: "Sent to providers when a booking is created or assigned.",
    variables: ["customerName", "serviceName", "bookingDate", "bookingTime", "scheduledServiceTime"],
    title: "New Booking Request",
    body: "{{customerName}} booked {{serviceName}} for {{bookingDate}} {{bookingTime}}.",
  },
  {
    key: "BOOKING_CREATED",
    name: "Booking Created",
    category: "Bookings",
    description: "Sent to customers when their booking is created.",
    variables: ["serviceName", "bookingDate", "bookingTime"],
    title: "Booking Created",
    body: "Your {{serviceName}} booking for {{bookingDate}} {{bookingTime}} has been received.",
  },
  {
    key: "BOOKING_ACCEPTED",
    name: "Booking Accepted",
    category: "Bookings",
    description: "Sent to customers when a provider accepts a booking.",
    variables: ["providerName", "serviceName", "bookingDate", "bookingTime"],
    title: "Booking Accepted",
    body: "{{providerName}} accepted your {{serviceName}} booking for {{bookingDate}} {{bookingTime}}.",
  },
  {
    key: "BOOKING_CANCELLED",
    name: "Booking Cancelled",
    category: "Bookings",
    description: "Sent when a booking is cancelled, rejected, or reassigned.",
    variables: ["serviceName", "bookingDate", "bookingTime"],
    title: "Booking Cancelled",
    body: "Your {{serviceName}} booking for {{bookingDate}} {{bookingTime}} was cancelled.",
  },
  {
    key: "BOOKING_STARTED",
    name: "Booking Started",
    category: "Bookings",
    description: "Sent when service starts.",
    variables: ["serviceName"],
    title: "Service Started",
    body: "Your {{serviceName}} booking is now in progress.",
  },
  {
    key: "BOOKING_COMPLETED",
    name: "Booking Completed",
    category: "Bookings",
    description: "Sent when service is marked completed.",
    variables: ["serviceName"],
    title: "Service Completed",
    body: "Your {{serviceName}} service was completed.",
  },
  {
    key: "BOOKING_REMINDER_PROVIDER",
    name: "Provider Booking Reminder",
    category: "Bookings",
    description: "Sent to providers before a booking starts (all reminder windows).",
    variables: ["reminderLabel", "serviceType", "customerLocation", "scheduledServiceTime"],
    title: "Service reminder: {{reminderLabel}} left",
    body: "Service: {{serviceType}} | Location: {{customerLocation}} | Scheduled: {{scheduledServiceTime}}",
  },
  {
    key: "BOOKING_REMINDER_CUSTOMER",
    name: "Customer Booking Reminder",
    category: "Bookings",
    description: "Sent to customers before booking starts (all reminder windows).",
    variables: ["reminderHours", "serviceName", "bookingDate", "bookingTime"],
    title: "Booking reminder: {{reminderHours}}h left",
    body: "Your {{serviceName}} booking starts in {{reminderHours}} hour(s) at {{bookingTime}} on {{bookingDate}}.",
  },
  {
    key: "NEW_LEAD",
    name: "New Lead Available",
    category: "Leads",
    description: "Sent to providers when a lead is broadcast.",
    variables: ["customerName", "serviceName", "providerEarnings"],
    title: "New Lead Available",
    body: "{{customerName}} needs {{serviceName}}. You will earn {{providerEarnings}}. Claim now!",
  },
  {
    key: "LEAD_ACCEPTED",
    name: "Lead Accepted",
    category: "Leads",
    description: "Sent to customers when a provider accepts their lead.",
    variables: ["providerName", "serviceName", "price"],
    title: "Provider Found!",
    body: "{{providerName}} accepted your {{serviceName}} request. Tap to review and pay.",
  },
  {
    key: "LEAD_CLAIMED_BY_OTHER",
    name: "Lead Claimed By Other",
    category: "Leads",
    description: "Sent to providers when another provider claims the lead.",
    variables: ["serviceName"],
    title: "Lead No Longer Available",
    body: "The {{serviceName}} lead was accepted by another provider.",
  },
  {
    key: "VISA_EXPIRED",
    name: "VISA Expired",
    category: "Compliance",
    description: "Sent when a provider VISA has expired.",
    variables: ["expiryDate"],
    title: "Account paused: VISA expired",
    body: "Your VISA has expired and your account has been paused. Please update your VISA details.",
  },
  {
    key: "VISA_REMINDER",
    name: "VISA Reminder",
    category: "Compliance",
    description: "Sent before VISA expiry.",
    variables: ["daysRemaining", "expiryDate"],
    title: "VISA expires in {{daysRemaining}} day(s)",
    body: "Please update your VISA details in the app to avoid account pause.",
  },
  {
    key: "PASSPORT_TERMINATION_NOTICE",
    name: "Passport Termination Notice",
    category: "Compliance",
    description: "Final-week notice before passport expiry.",
    variables: ["daysRemaining", "expiryDate"],
    title: "Passport expiry: service termination notice",
    body: "Your account will be restricted from receiving new leads from My Local Force due to passport expiry.",
  },
  {
    key: "PASSPORT_EXPIRY_REMINDER",
    name: "Passport Reminder",
    category: "Compliance",
    description: "Weekly reminder before passport expiry.",
    variables: ["daysRemaining", "expiryDate"],
    title: "Passport expires in {{daysRemaining}} day(s)",
    body: "Please upload your renewed passport now to avoid account restriction.",
  },
  {
    key: "PASSPORT_EXPIRED_FINAL",
    name: "Passport Expired Final",
    category: "Compliance",
    description: "Sent when passport expiry has taken effect.",
    variables: ["expiryDate"],
    title: "Passport expired: account restricted",
    body: "Your account will be restricted from receiving new leads from My Local Force due to passport expiry.",
  },
  {
    key: "DRIVING_LICENCE_TERMINATION_NOTICE",
    name: "Driving Licence Termination Notice",
    category: "Compliance",
    description: "Final-week notice before driving licence expiry.",
    variables: ["daysRemaining", "expiryDate"],
    title: "Driving licence expiry: service termination notice",
    body: "Your account will be restricted from receiving new leads from My Local Force due to driving licence expiry.",
  },
  {
    key: "DRIVING_LICENCE_EXPIRY_REMINDER",
    name: "Driving Licence Reminder",
    category: "Compliance",
    description: "Weekly reminder before driving licence expiry.",
    variables: ["daysRemaining", "expiryDate"],
    title: "Driving licence expires in {{daysRemaining}} day(s)",
    body: "Please upload your renewed driving licence now to avoid account restriction.",
  },
  {
    key: "DRIVING_LICENCE_EXPIRED_FINAL",
    name: "Driving Licence Expired Final",
    category: "Compliance",
    description: "Sent when driving licence expiry has taken effect.",
    variables: ["expiryDate"],
    title: "Driving licence expired: account restricted",
    body: "Your account will be restricted from receiving new leads from My Local Force due to driving licence expiry.",
  },
];
